import { Directive, ElementRef, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import Swal from 'sweetalert2';
var moment = require('moment');
import * as $ from 'jquery';

@Directive({
    selector: '[findate]'
})

export class FinancialDate implements OnChanges {

    @Input('ngModel') finDateValue;
    @Input('changeEvent') changeEvent;
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);
    @Output() onDateChange = new EventEmitter(false);

    FStartDate: any;
    FEndDate: any;
    static parameters = [ElementRef];

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg
        });
    }

    constructor(private el: ElementRef) {
        let Permission = JSON.parse(localStorage.getItem('permission'));
        if (Permission.length > 0) {
            this.FStartDate = new Date(Permission[0]['Fyear_FromDate']);
            this.FStartDate.setHours(0, 0, 0, 0);
            this.FEndDate = new Date(Permission[0]['Fyear_ToDate']);
            this.FEndDate.setHours(0, 0, 0, 0);
        }
    }

    ngOnChanges(event) {
        if (event && event.finDateValue && event.finDateValue['currentValue']) {
            let CurrentDate: any = new Date(event.finDateValue['currentValue']);
            if (!isNaN(Date.parse(CurrentDate))) {
                CurrentDate.setHours(0, 0, 0, 0);
                if (this.IsValidDate(CurrentDate) == false) {
                    this.toastWarningMsg("date must be between selected financial year");
                    let Value: any;
                    if (event && event.finDateValue && this.IsValidDate(event.finDateValue['previousValue'])) {
                        Value = new Date(event.finDateValue['previousValue']);
                    } else {
                        let DateNow: any = new Date();
                        DateNow.setHours(0, 0, 0, 0);
                        if ((DateNow - this.FStartDate) < 0 || (this.FEndDate - DateNow) < 0) {
                            DateNow = this.FEndDate;
                        }
                        // DateNow.setFullYear(this.FStartDate.getFullYear());
                        // if ((DateNow - this.FStartDate) < 0) {
                        //     DateNow.setFullYear(this.FEndDate.getFullYear());
                        // }
                        Value = DateNow;
                    }
                    this.el.nativeElement.value = moment(Value).format('DD-MMM-YYYY');
                    this.ngModelChange.emit(Value);
                    if (this.changeEvent) {
                        this.onDateChange.emit(Value)
                    };
                } else {
                    if (this.changeEvent) {
                        this.onDateChange.emit(new Date(CurrentDate));
                    };

                }
            } else {
                this.toastWarningMsg("invalid date");
                if (this.changeEvent) {
                    this.onDateChange.emit(new Date(CurrentDate));
                };
            }
        }
    }

    IsValidDate(CurrentDate) {
        if (isNaN(Date.parse(CurrentDate))) {
            return false;
        }
        if ((CurrentDate - this.FStartDate) < 0 || (this.FEndDate - CurrentDate) < 0) {
            return false;
        }
        return true;
    }
}